import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import {IdentityClient} from '../api/api-client';
import {SubscriptionManager} from './subscription-manager.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private readonly subscriptionManager:SubscriptionManager,
    private readonly identityService: IdentityClient,
    private readonly authService:AuthService,
    private readonly router:Router
  ) {}

  get isLoggedIn(){
    return this.authService.isLoggedIn;
  }
  logout() {
    this.subscriptionManager.call(
    this.identityService.logout(),
      (()=>{
      this.authService.isLoggedIn = false;
      this.authService.signOut();
      this.router.navigate(["/login"]);
    })
    );
  }
}
